<template>
    <div>
        <nav-bar />
        <div class="filter-button-group mb-2">
            <toggle-button-group
                :buttons="filterOptions" 
                :activeButton="selectedFilter" 
                :handleClick="handleFilterButtonClick" 
            />
        </div>

        <div>
            <div class="kne-title p-10">
                <h3>{{ $t('Clients.title') }}</h3>
            </div>

            <div class="df fw">
                <h4 style="padding-left: 20px; margin-top: 1rem">Selected group : {{ selectedGroup && selectedGroup.name ? selectedGroup.name : '-' }}</h4>
                <button v-if="isAdmin" id="addOrder" class="btn m-l-a btn-kne-orange" @click="showAddModal = true">
                    {{$t('Clients.add_client_file')}}
                </button>
                <button id="addOrder" class="btn btn-kne-orange" v-if="isAdmin" @click="showValidateClientsModal = true">
                    {{ $t('Clients.validate_clients') }}
                </button>
            </div>

            <new-client-modal v-if="showAddModal" @closeModal="closeModal" />
            <update-client-modal v-if="showUpdateModal" @closeModal="closeModal" class="waf-modal"
            :clientFile="clientFile"></update-client-modal>

            <validate-clients-modal v-if="showValidateClientsModal" :arrOfClientFile="sortedFiles" @closeModal="closeModal" />

            <div class="main">
                <div class="list-div bg-darkgrey navbar-inverse side-box-shadow" >
                    <ul class="nav flex-column">
                    <li v-for="item in groups" :key="item.id" class="nav-item" :class="{'current': selectedGroup.name === item.name}">
                        <a class="nav-link navbar-text pull-left d-b"  @click="handleItemClick(item)">{{ item.name }}
                        </a>
                    </li>
                    </ul>
                </div>
                <div class="card-div">
                    <div class="cards-div">
                        <div v-if="clientIds.includes(item.id)" class="wall-file-card card" v-for="(item, index) in selectedClientFiles" :key="index">
                            <h4 class="kne-title" :disabled="isLoading" @click="navigateToZone(item)">
                                <div class="df">
                                    <div>
                                        {{ item.name }}
                                    </div>
                                </div>
                            </h4>
                            <div class="info-card">
                                <div style="font-weight: 600;">Total Orders : <span> {{ item.totalOrders || '0' }} </span></div>
                                <div style="height: 24px;"></div>
                                <div style="height: 24px;"></div>
                                <div style="height: 24px;"></div>
                                <div style="display: flex;">
                                    <button class="btn-del" @click="editDriverFile(item)" v-if="isAdmin">
                                        <i class="fa fa-pencil" aria-hidden="true" />
                                    </button>
                                    <button class="btn-del" @click="deleteClientFile(item.id)" v-if="isAdmin">
                                        <i class="fa fa-trash" aria-hidden="true" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

    </div>
</template>

<script>
import { db } from '../../firebase'
import RegularInput from '../module/basic-components/regularInput'
import HoverToolTip from '../module/basic-components/hoverToolTip.vue'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import NewClientModal from '../module/special-components/Modal-templates/NewClient-modal.vue'
import UpdateClientModal from '../module/special-components/Modal-templates/UpdateClient-modal.vue'
import DefaultOrderModal from '../module/special-components/Modal-templates/DefaultOrder-modal.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import ValidateClientsModal from '../module/special-components/Modal-templates/ValidateClients-modal.vue'
import Draggable from 'vuedraggable'
import { isRegularOrder } from '@/inventory/inventorySelectors'

export default {
    name: 'Clients',
    components: {
        RegularInput,
        HoverToolTip,
        SidebarToggleButton,
        NewClientModal,
        UpdateClientModal,
        DefaultOrderModal,
        ToggleButtonGroup,
        ValidateClientsModal,
        Draggable
    },

    data () {
        return {
            clientFiles: [],
            selectedClientFiles: [],
            showValidateClientsModal: false,
            showUpdateModal: false,
            list: 'Main',
            isLoading: true,
            clientFile: {},
            processing: [],
            orders: [],
            groups: [],
            showAddGroup: false,
            selectedGroup: {},
            groupIdToSelect: '',
            clientIds: [],
            showAddModal: false,
            bookmarks: [],
            selectedClientFileOptions: [],
            selectedFilter: 'client',
            filterOptions: [
                { label: this.$t('NavBar.wallfile'), value: 'wallfile', route: '/WallFile' },
                { label: this.$t('NavBar.drivers'), value: 'driver', route: '/Drivers' },
                { label: this.$t('NavBar.clients'), value: 'client', route: '/Clients' }
            ],
            groupListener: null
        }
    },
    async created () {
        this.getClients()
        await this.getClientFiles()
        this.isLoading = false

        const groupId = this.$route.query.groupId
        if (groupId) {
            this.groupIdToSelect = groupId
        }
        await this.getGroups()
    },
    async mounted () {
    },
    beforeDestroy () {
      if (this.groupListener) {
        db.ref('database/groups/transporter').child(this.companyUID).child('clients').child('group').off('value', this.groupListener)
      }
    },
    methods: {
        handleFilterButtonClick (buttonName) {
            this.selectedFilter = buttonName

            const selectedOption = this.filterOptions.find(option => option.value === buttonName)
            if (selectedOption && selectedOption.route) {
                this.$router.push(selectedOption.route)
            }
        },
        async getGroups () {
            this.groupListener = await db.ref('database/groups/transporter').child(this.companyUID).child('clients').child('group').on('value', (snapshot) => {
                if (!snapshot.exists()) {
                this.groups = []
                return
                }
                this.groups = Object.entries(snapshot.val()).map(([id, zoneData]) => ({
                    id,
                    ...zoneData
                }))
                // Select the group from URL if available
                if (this.groupIdToSelect && this.groups.length > 0) {
                    const groupToSelect = this.groups.find(g => g.id === this.groupIdToSelect)
                    if (groupToSelect) {
                        this.handleItemClick(groupToSelect)
                    }
                    this.groupIdToSelect = null
                } else {
                    const groupToSelect = this.groups[0] || null
                    this.handleItemClick(groupToSelect)
                }
            })
        },
        handleItemClick (item) {
            this.clientIds = []
            this.selectedClientFiles = []
            let selectedGroups = this.groups.filter(g => g.id === item.id)
            if (!selectedGroups.length) return
            this.selectedGroup = selectedGroups[0]
            this.$router.push({
                query: { groupId: item.id }
            })
            Object.keys(this.selectedGroup.clientFiles).forEach(key => {
                this.clientIds.push(key)
            })
            this.clientFiles.forEach(client => {
                if (this.clientIds.includes(client.id)) {
                    client.priority = this.selectedGroup.clientFiles[client.id]
                    client.index = this.selectedGroup.clientFiles[client.id]
                } else {
                    client.priority = Number.MAX_VALUE
                    client.index = Number.MAX_VALUE
                }
            })
            this.clientFiles = this.clientFiles.sort((a, b) => a.index - b.index)
            this.selectedClientFiles = this.clientFiles.filter(df => this.clientIds.includes(df.id))
            this.$forceUpdate()
        },
        getClients () {
            this.$bindAsArray('clients', db.ref('users/pending-creation').orderByChild('transporterUid').equalTo(this.companyUID), null, () => {
                this.getClientFiles()
            })
        },
        getClientFiles () {
            db.ref('database/clientfiles/transporter').child(this.companyUID).child('clientfile').once('value', (snapshot) => {
                const clientFilesData = snapshot.val() || {}
                let index = 10000000
                this.clientFiles = Object.entries(clientFilesData).map(([id, data]) => {
                    index++
                    const clientFilter = this.clients.filter(client => client['.key'] === data.client)
                    const clientInfo = clientFilter ? clientFilter[0] : {}
                    return {
                        id,
                        ...data,
                        data: clientInfo,
                        index: data.index || index,
                        priority: data.index || index,
                        clientName: clientInfo ? clientInfo.name : ''
                    }
                })
                this.clientFiles = this.sortData(this.clientFiles)

                if (this.selectedGroup) {
                    this.handleItemClick(this.selectedGroup)
                }
                this.getOrders()
            })
            .catch(error => {
                confirm('Unable to fetch client files')
                console.error('Error fetching client files:', error)
            })
        },
        getOrders () {
            // Use store deliveries instead of binding
            if (!this.$store.state.deliveriesLoaded) {
                this.$store.dispatch('subscribeToDeliveries')
            }
            this.processOrders()
        },
        processOrders () {
            this.processing = this.$store.state.deliveries.filter(isRegularOrder)
            this.clientFiles.forEach(file => {
                file.totalOrders = 0
            })
            this.clientFiles.forEach(file => {
                this.processing.forEach(order => {
                    if (order.payer === file.client) file.totalOrders += 1
                })
            })
            this.isLoading = false
            this.$forceUpdate()
        },
        deleteClientFile (clientFile) {
            if (!confirm('Please confirm to delete')) return

            db.ref('database/clientfiles/transporter').child(this.companyUID).child('clientfile').child(clientFile).remove()
                .then(() => {
                    console.log('clientFile deleted')
                    this.closeModal()
                })
                .catch(error => {
                    confirm('Error deleting wall file')
                    console.error('Error deleting clientFile from firebase:', error)
                })
        },
        navigateToZone (clientFile) {
            if (this.isLoading) return
            if (!clientFile || !clientFile.totalOrders) {
                confirm('No orders found for the client')
                return
            }
            this.$router.push({
                name: 'Zone',
                params: {
                    client: clientFile
                }
            })
        },
        editDriverFile (file) {
            this.showUpdateModal = true
            this.clientFile = file
        },
        async closeModal () {
            this.showAddModal = false
            this.showUpdateModal = false
            this.showValidateClientsModal = false
            await this.getGroups()
            this.getClients()
            this.getClientFiles()
        },
        sortData (arr) {
            return arr.sort((a, b) => {
                const aIndex = a.index || Number.MAX_VALUE
                const bIndex = b.index || Number.MAX_VALUE
                return bIndex - aIndex
            })
        }
    },
    computed: {
        companyUID () {
            return this.$store.state.authorization.company
        },
        uid () {
            return this.$store.state.user.uid
        },
        sortedClientFiles () {
            return this.sortData(this.clientFiles.map(cf => cf))
        },
        sortedFiles () {
            return this.sortData([...this.clientFiles])
        },
        isAdmin () {
            return this.$store.state.authorization.role === 'Admin'
        },
        storeDeliveries () {
            return this.$store.state.deliveries
        }
    },
    watch: {
        storeDeliveries: {
            handler () {
                if (this.clientFiles.length > 0) {
                    this.processOrders()
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.card-div {
  flex: 2;
  height: calc(100vh - 170px);
  overflow-y: auto;
  scrollbar-width: thin;
}

.current {
  border-left: 3px solid #f7941e;
}
.nav-link {
  cursor: pointer;
}
.main {
  display: flex;
  width: 100%;
}

.list-div {
  height: calc(100vh - 170px);
  overflow-y: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  scrollbar-width: thin;
  width: 200px;
}

.d-b {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.df {
  display: flex;
  flex-wrap:wrap;
}
.cards-div {
    display: flex;
    padding: 20px;
    gap: 13px;
    flex-wrap: wrap;
}

.kne-title {
    margin-bottom: 0;
}

.wall-file-card {
    width: 19%;
    min-width: 300px;
}

.info-card {
    padding: 15px;
}

.btn-del {
    color: black;
    background: none;
    border: none !important;
}

.m-l-a {
    margin-left: auto;
}

.btn-del:active, .btn-del:focus {
  outline: none;
  border: none !important;
}

#addOrder {
    margin-right: 15px;
    margin-top: 1rem;
}

.cards-div .kne-title div {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.df {
    display: flex;
}

.p-10 {
    padding: 10px;
}

@media (max-width: 450px) {
    .wall-file-card {
        width: 100%;
    }

    #addOrder {
        margin-left: 20px;
        width: 100%;
    }
    .select {
        width: 100% !important;
        margin-right: 20px;
    }
    .fw {
        flex-wrap: wrap;
    }
}
</style>
